// Styles
import './_main-search.scss';